// extracted by mini-css-extract-plugin
module.exports = {"method_item":"PaymentMethod_method_item__V6wv5","active":"PaymentMethod_active__x49PX","error":"PaymentMethod_error__pKnV5","payment_method":"PaymentMethod_payment_method__V_tc0"};